export default {
    filters: {
        title: "Filtros",
        removeFilter: "Remover filtro",
        filterIntensity: "Intensidade do filtro",
        duotone: {
            title: "Duotono",
            desert: "Deserto",
            peach: "Pêssego",
            clash: "Conflito",
            plum: "Ameixa",
            breezy: "Airoso",
            deepBlue: "Azul profundo",
            frog: "Sapo",
            sunset: "Pôr do sol",
        },
        blackAndWhite: {
            title: "Preto e Branco",
            ad: "1920 D.C",
            greyed: "Acinzentada",
            dusty: "Poeirento",
            litho: "Litho ",
            sepia: "Sépia",
            weathered: "Weathered",
            hardStuff: "Coisas difíceis",
        },
        vintage: {
            title: "Retro",
            polaroid: "Fotografia instantânea",
            sunny: "Anos 70 ensolarados",
            oldTimer: "Antiguidade",
            inferno: "Inferno",
            snappy: "Esperto",
        },
        smooth: {
            title: "Suave",
            chestnut: "Castanha",
            softy: "Molezinha",
            pebble: "Seixo",
            moss: "Musgo ",
            lemon: "Limão",
            greenGap: "Acuna verde",
        },
        cold: {
            title: "Frio",
            colla: "Grupo",
            solanus: "Solanus",
            kalmen: "Quilman",
            jorah: "Joran",
            levante: "Erga-se",
            zephyr: "Zéfiro",
        },
        warm: {
            title: "Quente",
            golden: "Dourado",
            lowFire: "Fogo baixo",
            sunrise: "Amanhecer",
            flatBack: "Casa sem quintal",
            pumpkin: "Abóbora",
        },
    },
};
